module.exports = __webpack_public_path__ + "SourceSansPro-SemiBoldItalic.5d0dd191754bcb2ee266.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-SemiBoldItalic.woff
// module id = ../../../../../src/assets/customfonts/SourceSansPro-SemiBoldItalic.woff
// module chunks = styles